import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConfigurableQuestionnairesState } from '../../entities';
import { CONFIGURABLE_QUESTIONNAIRES_FEATURE_KEY } from '../reducers';
import { questionnaireGroupsAdapter } from '../reducers/questionnaire-groups.reducer';

const questionnaireGroupsSelectors = questionnaireGroupsAdapter.getSelectors();

/** Feature selector */
const selectConfigurableQuestionnairesFeature = createFeatureSelector<ConfigurableQuestionnairesState>(
    CONFIGURABLE_QUESTIONNAIRES_FEATURE_KEY,
);

/** Questionnaire groups state */
const selectQuestionnaireGroupsState = createSelector(
    selectConfigurableQuestionnairesFeature,
    state => state.questionnaireGroups,
);

/** Select all questionnaire groups */
export const selectQuestionnaireGroups = createSelector(
    selectQuestionnaireGroupsState,
    questionnaireGroupsSelectors.selectAll,
);

/** Select visible questionnaire groups with at least one visible sub-group */
export const selectVisibleQuestionnaireGroups = createSelector(selectQuestionnaireGroups, groups =>
    groups.filter(
        group =>
            group.isVisible &&
            !!group.navigationUrl &&
            (group.questionnaireSubGroups ?? []).some(subGroup => subGroup.isVisible),
    ),
);

/** Select questionnaire groups entities */
export const selectQuestionnaireGroupsEntities = createSelector(
    selectQuestionnaireGroupsState,
    questionnaireGroupsSelectors.selectEntities,
);

/** Select questionnaire groups loading state */
export const selectQuestionnaireGroupsIsLoading = createSelector(
    selectQuestionnaireGroupsState,
    state => state.isLoading,
);

/** Select questionnaire groups error */
export const selectQuestionnaireGroupsError = createSelector(selectQuestionnaireGroupsState, state => state.error);
